/**
 * Confirmation Dialogs Constants
 * Contains all confirmation dialog configurations used across the application
 */

export const CONFIRMATION_DIALOG_CONSTANTS = {
  EDIT_PUBLISHED_VERSION: {
    header: 'Guardar Borrador',
    description:
      'No puedes realizar cambios en una versión publicada, si deseas continuar editando debes guardar esta modificación como un borrador y publicar una nueva versión.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Cancelar',
    confirmLabel: 'Guardar Borrador',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
    messageWidth: '560px',
  },
  UNSAVED_DRAFT_CHANGES: {
    header: '¿Quieres descartar los cambios?',
    description:
      'Has realizado cambios en este borrador. Si no los guardas, se perderán para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Sí, descartar cambios',
    confirmLabel: 'Guardar Cambios',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },
  DELETE_BEHAVIORAL_LINE: {
    header: 'Eliminar línea de comportamiento',
    description:
      '¿Estás seguro de que quieres eliminar esta línea comportamental? Esta acción no se puede deshacer.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Cancelar',
    confirmLabel: 'Eliminar',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },
  UNSAVED_VERSION_CHANGES: {
    header: '¿Quieres descartar los cambios?',
    description:
      'Has realizado cambios en esta versión. Si no los guardas, se perderán para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Sí, descartar cambios',
    confirmLabel: 'Guardar Cambios',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },
  SCHEDULED_VERSION_LOCKED: {
    header: 'No puedes editar esta versión',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Cerrar',
    discardBtnClass: 'btn-discard',
    messageWidth: '560px',
    showSecondaryButton: false,
  },
  UNSAVED_BEHAVIOR_CHANGES: {
    header: '¿Quieres descartar los cambios?',
    description:
      'Has realizado cambios en este comportamiento. Si no los guardas, se perderán para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Sí, descartar cambios',
    confirmLabel: 'Guardar Cambios',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },

  UNSAVED_ACTIVITY_CHANGES: {
    header: '¿Quieres descartar los cambios?',
    description:
      'Has realizado cambios en esta actividad. Si no los guardas, se perderán para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Sí, descartar cambios',
    confirmLabel: 'Guardar Cambios',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },

  UNSAVED_CHANGES: {
    header: '¿Quieres descartar los cambios?',
    description: 'Has realizado cambios. Si no los guardas, se perderán para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Sí, descartar cambios',
    confirmLabel: 'Guardar Cambios',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
    messageWidth: '410px',
  },
  UNSAVED_EDITOR_CHANGES_EXIT: {
    header: 'Descripción no guardada',
    description: 'Tienes una descripción en edición. Si sales ahora, se perderán los cambios.',
    secondaryDescription: '¿Deseas continuar editando o salir sin guardar?',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Continuar editando',
    confirmLabel: 'Salir sin guardar',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
    showEditorUnsavedSection: true,
  },
  UNSAVED_EDITOR_CHANGES_DISCARD: {
    header: 'Descripción no guardada',
    description: 'Tienes una descripción en edición. Si continúas, se perderán los cambios.',
    secondaryDescription: '¿Deseas continuar editando o descartar los cambios?',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Continuar editando',
    confirmLabel: 'Descartar cambios',
    discardBtnClass: 'btn-confirm',
    confirmBtnClass: 'btn-discard',
    showEditorUnsavedSection: true,
  },
  ADD_BEHAVIORS: {
    description: 'Agregar comportamientos de este team pragmapower',
    discardLabel: 'Cancelar',
    confirmLabel: 'Agregar',
  },
  INFORM_MISSIONS: {
    header: '¿Qué es una misión del reto?',
    iconSrc: 'assets/icons/information-purple.svg',
    showMissionsSection: true,
    showSecondaryButton: false,
    showPrimaryButton: false,
  },

  DISCART_CURRENT_MISSION: {
    header: '¿Eliminar esta misión?',
    iconSrc: 'assets/icons/information-purple.svg',
    description: 'Estás a punto de eliminar la misión:',
    secondaryDescription: 'Esta acción la quitará del reto y no se puede deshacer.',
    discardLabel: 'Cancelar',
    confirmLabel: 'Eliminar misión',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
  },
  CREATE_MISSIONS: {
    header: '¿Salir sin guardar cambios?',
    iconSrc: 'assets/icons/information-purple.svg',
    description:
      'Tienes cambios sin guardar en esta misión. Si sales ahora, se perderá la información que agregaste.',
    discardLabel: 'Salir sin guardar',
    confirmLabel: 'Seguir editando',
    discardBtnClass: 'btn-discard',
    confirmBtnClass: 'btn-confirm',
    messageWidth: '450px',
  },
  ENVIRONMENT_MISMATCH_MODAL: {
    header: 'Hubo un error al abrir el enlace',
    description:
      'El enlace del correo no te llevó al lugar correcto. No te preocupes, puedes entrar a Creci desde aquí.',
    confirmLabel: 'Ir a Creci',
    iconSrc: 'assets/icons/information-purple.svg',
    iconAlt: 'Información',
    showIcon: true,
    messagewidth: '480',
    showPrimaryButton: false,
    showSecondaryButton: true,
  },
  INFORM_PROFILE: {
    header: '¿Qué es el perfil profesional?',
    iconSrc: 'assets/icons/information-purple.svg',
    description:
      'El perfil profesional, se define a través de la conjunción de roles, responsabilidades, capacidades y la experiencia específica que un pragmático aporta para generar valor continuo.',
    showSecondaryButton: false,
    showPrimaryButton: false,
    messageWidth: '560px',
  },
  SIMILAR_ROLE: {
    header: '¿Qué es el rol equivalente en el medio?',
    iconSrc: 'assets/icons/information-purple.svg',
    description:
      'Rol homólogo como se conoce en el mercado, con funciones y responsabilidad similares al rol de Pragma.',
    showPrimaryButton: false,
    showSecondaryButton: false,
    messageWidth: '560px',
  },
  TEAM: {
    header: '¿Qué es unDSDS rol?',
    description:
      'El rol de una persona en Pragma se define como un elemento crucial en la conformación de equipos, ya sea para proyectos específicos o cuentas, buscando siempre la claridad de las responsabilidades para asegurar la entrega de valor. En general, la definición de roles se alinea con la estrategia de negocio, los objetivos del cliente, y las habilidades y conocimientos requeridos para alcanzar resultados grandiosos.',
    showSecondaryButton: false,
    showPrimaryButton: false,
    messageWidth: '560px',
  },
  ROL_HELP: {
    header: '¿Qué es un rol?',
    iconSrc: 'assets/icons/information-purple.svg',
    description:
      'El rol de una persona en Pragma se define como un elemento crucial en la conformación de equipos, ya sea para proyectos específicos o cuentas, buscando siempre la claridad de las responsabilidades para asegurar la entrega de valor.',
    secondaryDescription:
      'En general, la definición de roles se alinea con la estrategia de negocio, los objetivos del cliente, y las habilidades y conocimientos requeridos para alcanzar resultados grandiosos.',
    showSecondaryButton: false,
    showPrimaryButton: false,
    messageWidth: '560px',
  },
  CANCEL_EDIT_ROLE: {
    header: '¿Quieres cancelar la edición del rol?',
    description: 'Tienes cambios por guardar, si cancelas ahora los perderás para siempre.',
    iconSrc: 'assets/icons/information-purple.svg',
    discardLabel: 'Cancelar',
    confirmLabel: 'Regresar',
  },
};
